module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/operator/map"
// module id = 8
// module chunks = 0